// extracted by mini-css-extract-plugin
export default {"container":"circular-progress_container__j+Nfu","text":"circular-progress_text__yUV7c"};